module.exports = {"name":"gammaNotifications","meta":{"description":"Replaces the classic-powered notifications views within the embedded Gamma Header with the new gamma notifications. Does not affect the classic header. You'll need to enable the gammaHeader experiment along with this one to see changes.","link":"https://trello.atlassian.net/browse/WLRS-122"},"audiences":["allMembers"],"defaults":{"enabled":false},"defaultWeight":1,"experimentAllocation":0,"experimentVersion":"v1","variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/gammaNotifications.json
// module id = 3zBa
// module chunks = 13